import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=96504b00"
import script from "./EditModule.vue?vue&type=script&lang=js"
export * from "./EditModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports